module.exports = "<div class=\"container\">\n  <h3>{{(shoesToDisplay | async)?.name}}</h3>\n  <h4>{{(shoesToDisplay | async)?.price}}</h4>\n  <p>{{(shoesToDisplay | async)?.size}}</p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/juliusbade/Desktop/UnderArmour-Rebuild/src/app/shoes-detail/shoes-detail.component.html
// module id = ../../../../../src/app/shoes-detail/shoes-detail.component.html
// module chunks = main